import React, { useCallback, useState } from 'react';
import Header from '../../components/header/Header';
import LoaderComponent from '../../components/Loader.component';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';
import userStore from '../../../stores/user.store';
import {
    DangerButtonStyled,
    PrimaryButtonStyled
} from '../../../style/components/button.styled';
import { withRouter } from 'react-router';
import ChangePassword from './components/ChangePassword';
import MenuSettingsComponent
    from '../../components/menuSettings/MenuSettings.component';
import { addToast } from '../../components/toasts/Toast';

const Styles = styled.div`
  margin: 10px 20px;
`;

const DangerZoneStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border: 1px solid rgba(248, 107, 99, 0.35);
  border-left: 4px solid #F86B63;
  background: rgba(248, 107, 99, 0.02);
  border-radius: 6px;
  margin: 10px 0;

  h3 {
    font-size: 16px;
    font-weight: 700;
    color: #F86B63;
    margin: 0;
  }

  p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.62);
    line-height: 1.5;
    margin: 0;
  }

  .action-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
    
    .warning-text {
      font-size: 13px;
      font-weight: 700;
      color: #F86B63;
      margin-right: 8px;
    }
  }
`;

const ProfilePage = props => {
    document.title = 'Account Settings - SyAgent';

    return (
        <main>
            <Header/>
            <Styles>
                <SettingsPageWrapper
                    history={ props.history }
                />
            </Styles>
        </main>
    );
};

const SettingsPageWrapper = props => {
    return useObserver(() => (
        <SettingsPage
            history={ props.history }
            user={ userStore.user }
        />
    ));
};

const SettingsPage = props => {
    const { user } = props;
    const [areYouSureState, setAreYouSureState] = useState(false);
    const [deleteSending, setDeleteSending] = useState(false);

    const handleDelete = useCallback(async () => {
        if (deleteSending) {
            return;
        }

        setDeleteSending(true);
        try {
            await userStore.deleteUser();
            window.location.replace('/login');
        } catch (error) {
            addToast(error.message || 'Failed to delete account', 'error');
        } finally {
            setDeleteSending(false);
        }
    }, [deleteSending]);

    return (
        <>
            { !user && (
                <LoaderComponent/>
            ) }

            { user && (
                <MenuSettingsComponent
                    title={ 'Account Settings' }
                    menu={ [
                        {
                            title: 'Password'
                        },
                        {
                            title: 'Delete account'
                        }
                    ] }
                    content={ [
                        <ChangePassword
                            user={ user }
                        />,
                        <DangerZoneStyled>
                            <h3>Delete Account</h3>
                            <p>
                                Permanently delete your SyAgent account, configurations, and all monitored servers data. This action is irreversible.
                            </p>
                            <div className="action-row">
                                { !areYouSureState && (
                                    <DangerButtonStyled
                                        onClick={ () => setAreYouSureState(true) }
                                    >
                                        Delete Account
                                    </DangerButtonStyled>
                                ) }

                                { areYouSureState && (
                                    <>
                                        <span className="warning-text">Are you sure?</span>
                                        <DangerButtonStyled
                                            onClick={ handleDelete }
                                        >
                                            Yes, Delete Account
                                        </DangerButtonStyled>
                                        <PrimaryButtonStyled
                                            onClick={ () => setAreYouSureState(false) }
                                        >
                                            Cancel
                                        </PrimaryButtonStyled>
                                    </>
                                ) }
                            </div>
                        </DangerZoneStyled>
                    ] }
                />
            ) }
        </>
    );
};

export default withRouter(ProfilePage);
